"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _avatar = _interopRequireDefault(require("../avatar"));

var _card = _interopRequireDefault(require("../card"));

var _featuredBlogPostCardModule = _interopRequireDefault(require("./featuredBlogPostCard.module.css"));

const FeaturedBlogPostCard = _ref => {
  let {
    className,
    post,
    light,
    avatarProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_featuredBlogPostCardModule.default.featuredBlogPost, className)
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: _featuredBlogPostCardModule.default.blogPostCardLink,
    href: `/blog/${post.slug}`
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    className: _featuredBlogPostCardModule.default.blogPostCard,
    isElevated: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _featuredBlogPostCardModule.default.imageContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: _featuredBlogPostCardModule.default.image,
    src: post.featuredImage,
    alt: post.name
  }), /*#__PURE__*/_react.default.createElement("svg", {
    className: _featuredBlogPostCardModule.default.imageLaser,
    xmlns: "http://www.w3.org/2000/svg",
    width: "187",
    height: "38",
    viewBox: "0 0 187 38"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "featureblogpostcardlaser-a",
    x1: "15.436%",
    x2: "114.319%",
    y1: "51.21%",
    y2: "49.146%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC42A"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "#FF0061",
    stopOpacity: ".946"
  }))), /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "url(#featureblogpostcardlaser-a)",
    fillRule: "evenodd",
    points: "-.804 27.511 149.971 42.672 189.196 9.84 140.672 31.247",
    transform: "rotate(-6 94.196 26.256)"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _featuredBlogPostCardModule.default.postInfo
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: _featuredBlogPostCardModule.default.title
  }, post.name), /*#__PURE__*/_react.default.createElement("p", {
    className: _featuredBlogPostCardModule.default.description
  }, post.metaDescription)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_featuredBlogPostCardModule.default.author, light && _featuredBlogPostCardModule.default.light)
  }, /*#__PURE__*/_react.default.createElement(_avatar.default, (0, _extends2.default)({}, avatarProps, {
    className: _featuredBlogPostCardModule.default.avatar,
    darkText: light,
    image: post.blogAuthor && post.blogAuthor.avatar,
    fullName: post.blogAuthor && post.blogAuthor.fullName || post.authorName,
    title: post.blogAuthor && post.blogAuthor.title || null
  }))))));
};

FeaturedBlogPostCard.defaultProps = {
  className: '',
  post: {
    authorName: 'Default Author Name',
    blogAuthor: {
      avatar: 'https://s3-us-west-2.amazonaws.com/observian-team/assets/avatar.png',
      fullName: 'Default Name',
      title: 'Default Title'
    },
    featuredImage: '/images/blog-post-card/595x230.png',
    name: 'Iterate on your CloudFormation Development with CodePipeline',
    metaDescription: 'Differentiate and you stand out in a crowded marketplace. Present your uniqueness and emphasize your rare attributes in your sales copy and promotions for all. Differentiate and you stand out in a crowded marketplace. Present your uniqueness and emphasize your rare attributes in your sales copy and promotions for all.',
    slug: 'default-prop-type-slug'
  },
  light: true,
  avatarProps: {
    stackedText: true,
    withText: true,
    forceAspectRatio: false
  }
};
FeaturedBlogPostCard.propTypes = {
  className: _propTypes.default.string,
  post: _propTypes.default.shape({
    authorName: _propTypes.default.string,
    blogAuthor: _propTypes.default.shape({
      avatar: _propTypes.default.string,
      fullName: _propTypes.default.string,
      title: _propTypes.default.string
    }),
    featuredImage: _propTypes.default.string,
    name: _propTypes.default.string,
    metaDescription: _propTypes.default.string,
    slug: _propTypes.default.string
  }),
  light: _propTypes.default.bool,
  avatarProps: _propTypes.default.shape({
    stackedText: _propTypes.default.bool,
    withText: _propTypes.default.bool,
    forceAspectRatio: _propTypes.default.bool
  })
};
var _default = FeaturedBlogPostCard;
exports.default = _default;